import { render, staticRenderFns } from "./agentordertable-component.vue?vue&type=template&id=ae7abd12"
import script from "./agentordertable-component.vue?vue&type=script&lang=ts"
export * from "./agentordertable-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports